import { Component, OnInit, ElementRef } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { NotificationService } from '../_services/notification.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forgot-pass-change',
  templateUrl: './forgot-pass-change.component.html'
})
export class ForgotPassChangeComponent implements OnInit {
  private toggleButton: any;
  private sidebarVisible: boolean;
  private nativeElement: Node;
  password: string;
  confirmPassword: string;
  model: any = {};

  constructor(public authService: AuthService, private notify: NotificationService, private router: Router, private route: ActivatedRoute,
      private element: ElementRef) {
      this.nativeElement = element.nativeElement;
      this.sidebarVisible = false;
  }

  ngOnInit() {
      var navbar : HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('login-page');
      body.classList.add('off-canvas-sidebar');
      const card = document.getElementsByClassName('card')[0];
      setTimeout(function() {
        // after 1000 ms we add the class animated to the login/register card
        card.classList.remove('card-hidden');
    }, 700);
}

  changePass(){
    if (this.confirm()) {
      var tok = this.route.snapshot.queryParamMap.get('token')
      this.route.queryParamMap.subscribe(queryParams => {
      tok = queryParams.get('token');
      });
      this.model.token = tok;
      this.model.password = this.password;
      this.authService.changePassword(this.model).subscribe(() => {
        this.notify.success('Uspesno izmenjena sifra');
      }, error => {
        this.notify.error('Vas zahtev za promenu lozinke je istekao. Posaljite ponovo.')
      }, () => {
        this.router.navigate(['/login']);
      });
    } else {
      this.notify.error('Lozinke se moraju poklapati')
    }
  }

  confirm(){
    if (this.password === this.confirmPassword) {
      return true;
    }
    return false;
  }

  sidebarToggle() {
      var toggleButton = this.toggleButton;
      var body = document.getElementsByTagName('body')[0];
      var sidebar = document.getElementsByClassName('navbar-collapse')[0];
      if (this.sidebarVisible == false) {
          setTimeout(function() {
              toggleButton.classList.add('toggled');
          }, 500);
          body.classList.add('nav-open');
          this.sidebarVisible = true;
      } else {
          this.toggleButton.classList.remove('toggled');
          this.sidebarVisible = false;
          body.classList.remove('nav-open');
      }
  }
  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');
  }

}
